import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { RISK_COLORS, type RiskLevel } from '../../types';

interface RiskMarkerProps {
  lat: number;
  lon: number;
  risk_level: RiskLevel;
}

export default function RiskMarker({ lat, lon, risk_level }: RiskMarkerProps) {
  const map = useMap();

  useEffect(() => {
    const color = RISK_COLORS[risk_level];
    const isHighRisk = risk_level === 'High' || risk_level === 'Extreme';

    const marker = L.circleMarker([lat, lon], {
      radius: 15,
      fillColor: color,
      color: '#fff',
      weight: 3,
      opacity: 1,
      fillOpacity: 0.85,
      className: isHighRisk ? 'pulse-marker' : '',
    }).addTo(map);

    const ring = L.circleMarker([lat, lon], {
      radius: 25,
      fillColor: 'transparent',
      color: color,
      weight: 2,
      opacity: 0.5,
      fillOpacity: 0,
    }).addTo(map);

    return () => {
      map.removeLayer(marker);
      map.removeLayer(ring);
    };
  }, [map, lat, lon, risk_level]);

  return null;
}
